import type { ScoreColumn, StudentTransferMapping } from "./types";

const normalizeName = (name: string) => name.trim().replace(/\s+/g, " ").toLocaleLowerCase("vi");

export function suggestTransferMappings(source: ScoreColumn[], target: ScoreColumn[]): StudentTransferMapping[] {
  const used = new Set<string>();
  return source.map((column) => {
    const match = target.find((candidate) => !used.has(candidate.id) && candidate.mode === column.mode && normalizeName(candidate.shortLabel) === normalizeName(column.shortLabel));
    if (match) used.add(match.id);
    return { sourceColumnId: column.id, targetColumnId: match?.id ?? null };
  });
}

export function transferColumnNames(source: ScoreColumn[], target: ScoreColumn[], mappings: StudentTransferMapping[]) {
  const names = new Set(target.map((column) => normalizeName(column.shortLabel)));
  const result = new Map<string, string>();
  for (const mapping of mappings) {
    if (mapping.targetColumnId !== null) continue;
    const column = source.find((item) => item.id === mapping.sourceColumnId);
    if (!column) continue;
    let name = column.shortLabel;
    let suffix = 1;
    while (names.has(normalizeName(name))) {
      const ending = ` (${++suffix})`;
      name = column.shortLabel.slice(0, 40 - ending.length) + ending;
    }
    names.add(normalizeName(name));
    result.set(column.id, name);
  }
  return result;
}
